import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';


@Injectable({
  providedIn: 'root'
})
export class ClientService {
  clients: any = [];
  constructor(private http: HttpClient) {
    this.clients = [];
    console.log("clients initialized!!!!!!!", this.clients)
  }

  addClient(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "clients", data).subscribe((res: any) => {

        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  editClient(data: any): Observable<any> {
    console.log("Edit clients", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "clients", data).subscribe((res: any) => {
        console.log("Edited Course : ", res);
        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  deleteClient(id, flag) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "clients?flag=" + flag + "&_id=" + id).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }
  // Delete Location
  deleteLocation(id) {
    console.log("Delete location", id);

    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "clients/location?_id=" + id).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }




  downloadSitePrint(data): Observable<any> {
    // var that = this;

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "clients/download-site", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        if (res && res.data) {
          const downloadLink = document.createElement("a");
          downloadLink.href = res.data;

          downloadLink.click();
        }
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  getClients(): Observable<any> {
    console.log("Getting clients");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "clients").subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data.clients);
      }, error => {
        observer.error(error)
      }, () => {
        observer.complete();
      })

    });
  }
  getClient(id): Observable<any> {
    console.log("Getting clients");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "clients?_id=" + id).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data.clients);
        observer.complete();
      })

    });
  }

  getClientUserList(id): Observable<any> {
    console.log("Getting clients");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "clients/client-users?_id=" + id).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data.clients);
        observer.complete();
      })
    });
  }


  addLocation(data: any): Observable<any> {
    console.log("Adding location", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "clients/location", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data.location)
        observer.next(res.data.location);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  updateLocation(data: any): Observable<any> {
    console.log("Adding location", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "clients/location", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data.location)
        observer.next(res.data.location);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }




  getSiteList(data: any): Observable<any> {
    console.log("Adding location", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "clients/location?_query=" + data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data.location)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  // Get project code list of all clients
  getProjectCodeList(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "clients/project-codes").subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }
}
